import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

// Redux
import { connect } from "react-redux";
import genericAction from "@Actions/generic";

//	Utils
import dataHandler from "@Utils/dataHandler";

// Modal
import ConfirmModal from "@Modals/ConfirmModal";

// Components
import Screen from "@Components/Screen";
import IkTable from "@Components/IkTable";
import Profile from "./Modals/Profile";

// Styles
import styles from "./styles.module.css";

const Profiles = ({ dispatch, companyName, userName }) => {
	const [tableValue, setTableValue] = useState([]);
	const [openConfirmModal, setOpenConfirmModal] = useState(false);
	const [openProfilesCrud, setOpenProfilesCrud] = useState(false);
	const [filteredItems, setFilteredItems] = useState([]);
	const [filteredCount, setFilteredCount] = useState([]);
	const [filteredPrintData, setFilteredPrintData] = useState([]);
	const [modalOption, setModalOption] = useState("");
	const [menuData, setMenuData] = useState("");
	const [currentParams, setCurrentParams] = useState({ page: 1, orderKey: "id", orderDir: "desc", rows: 15 });

	const defaultParams = { page: 1, orderKey: "id", orderDir: "desc", rows: 15 };

	useEffect(() => {
		(async () => {
			const profilesPromise = dataHandler({ dispatch, url: "profiles", params: defaultParams });
			const menuPromise = dispatch(genericAction({ method: "get", route: "menu/all" }));

			const [profilesResponse, menuResponse] = await Promise.all([profilesPromise, menuPromise]);
			setFilteredCount(profilesResponse.count);
			setFilteredItems(profilesResponse.items);
			setCurrentParams(defaultParams);
			setMenuData(menuResponse);
		})();
	}, []);

	// modal handlers
	const modalData = (name, item) => {
		setTableValue(item);
		setModalOption(name);
		setOpenProfilesCrud(true);
	};

	// Table handlers
	const handlerData = async (params, printable) => {
		const data = await dataHandler({ dispatch, url: "profiles", params });
		if (printable) {
			setFilteredPrintData(data.items);
		} else {
			setFilteredItems(data.items);
			setFilteredCount(data.count);
			setCurrentParams(params);
		}
	};

	const handleButtom = (name, item) => {
		switch (name) {
			case "Watch":
				modalData(name, item);
				break;
			case "Edit":
				modalData(name, item);
				break;
			case "Eraser":
				setOpenConfirmModal(true);
				setTableValue(item);
				break;
			case "Add":
				modalData(name, []);
				break;
			default:
				break;
		}
	};

	const apiData = async (name) => {
		switch (name) {
			case "Edit":
				setOpenProfilesCrud(false);
				break;
			case "Eraser":
				setOpenConfirmModal(false);
				await dispatch(genericAction({ method: "delete", route: `profiles/${tableValue.id}` }));
				break;
			default:
				break;
		}
		const profilesResponse = await dataHandler({
			dispatch,
			url: "profiles",
			params: currentParams,
		});
		setFilteredCount(profilesResponse.count);
		setFilteredItems(profilesResponse.items);
	};

	return (
		<Screen hasHeader hasSidebar headerTitle="Perfiles">
			<div className={styles.container}>
				<div className={styles.containerTableGroup}>
					<div className={styles.tableGroupList}>
						<IkTable
							data={filteredItems}
							columns={[
								{
									label: "Acciones",
									action: [
										{ content: "trash", color: "#b43333", onClick: "Eraser", type: "icon" },
										{ content: "edit", color: "#3f7ea3", onClick: "Edit", type: "icon" },
									],
									dataPosition: "center",
									width: 1,
									canFilter: false,
									canSort: false,
								},
								{
									label: "ID",
									key: "id",
									format: "string",
									dataPosition: "center",
									width: 1,
								},
								{
									label: "Nombre",
									key: "name",
									format: "string",
									dataPosition: "left",
									headerPosition: "left",
									width: 14,
								},
							]}
							totalRows={filteredCount}
							filteredPrintData={filteredPrintData}
							defaultParams={defaultParams}
							dataHandler={handlerData}
							handlerTable={handleButtom}
							addButton={{ label: "Agregar" }}
							searcher={{ width: "40rem", hideOnMobile: true }}
							mobileCardView
							cardLine1={[
								{ key: "id", label: "ID" },
								{ key: "name", label: "" },
							]}
							hidePrintButtons
							print={{ printHeader: { company: companyName, title: "Perfiles", user: userName } }}
						/>
					</div>
				</div>
			</div>
			{openConfirmModal && (
				<ConfirmModal
					visible
					icon="exclamation circle"
					header="Confirmar"
					buttonLabel="Eliminar"
					content="Está seguro que desea eliminar el perfil"
					focus={tableValue.name}
					onConfirm={() => {
						apiData("Eraser");
					}}
					onDismiss={() => {
						return setOpenConfirmModal(false);
					}}
				/>
			)}

			{openProfilesCrud && (
				<Profile
					tableValue={tableValue}
					menuData={menuData}
					modalOption={modalOption}
					apiData={apiData}
					onClose={() => {
						return setOpenProfilesCrud(false);
					}}
				/>
			)}
		</Screen>
	);
};
function mapStateToProps({ user, company }) {
	return {
		companyName: company.name,
		userName: user.name,
	};
}

Profiles.propTypes = {
	dispatch: PropTypes.func,
	companyName: PropTypes.string,
	userName: PropTypes.string,
};
export default connect(mapStateToProps)(Profiles);
